import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonHoverAnimation from 'components/ButtonHoverAnimation';
import PackageHeader from 'components/PackageHeader';

import * as CustomPropTypes from 'lib/CustomPropTypes';
import TitleLogo from 'components/TitleLogo';

/**
 * Functional label component to add title information to bundles of packaged content. Can be
 * rendered multiple times on a page. Also renders a 'See All' button to link to additional content
 * packages.
 */
const CollectionTitle = (props) => {
  const { alignRight, content = {}, pkgClassName } = props;
  const { metadata = {}, packageIndex, context: { railContext } } = content;
  const {
    title, description, seeAllUrl, seeAllText, logoUrl,
  } = metadata || {};
  const isCollectionMountedLeft = railContext === 'left';

  const collectionTitleCx = classNames(
    'collection-title',
    'relative',
    pkgClassName,
    { 'collection-title__mirror': alignRight },
  );
  const packageHeaderTitleCx = classNames(
    'collection-title__title',
    { 'collection-title__title--is-left-mounted': isCollectionMountedLeft },
  );

  return (
    <section className={collectionTitleCx}>
      {
        (logoUrl || title)
        && (
        <PackageHeader className={packageHeaderTitleCx} packageIndex={packageIndex}>
          <TitleLogo logoUrl={logoUrl} title={title} />
        </PackageHeader>
        )
      }
      <p className="collection-title__dek">
        {description}
      </p>
      {
        seeAllUrl && (
          <ButtonHoverAnimation
            size="normal"
            type="link"
            url={seeAllUrl}
            hasDarkBackground
            title={seeAllText}
          />
        )
      }
    </section>
  );
};

CollectionTitle.propTypes = {
  content: CustomPropTypes.package.isRequired,
  alignRight: PropTypes.bool,
  pkgClassName: PropTypes.string,
};

CollectionTitle.defaultProps = {
  alignRight: false,
  pkgClassName: 'pkg',
};

CollectionTitle.contextTypes = {
  ...CustomPropTypes.layoutContext,
};

export default CollectionTitle;
